/* This file is based on `vscode-lean4/vscode-lean4/src/infoview.ts ` */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Uri, window, workspace, env } from 'vscode';
import { RpcErrorCode } from '@leanprover/infoview-api';
import { c2pConverter, fromLanguageServerPosition, fromLanguageServerRange, p2cConverter, toLanguageServerRange } from './utils/converters';
// import { logger } from './utils/logger'
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
var keepAlivePeriodMs = 10000;
function rpcConnect(client, uri) {
    return __awaiter(this, void 0, void 0, function () {
        var connParams, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    connParams = { uri: uri };
                    return [4 /*yield*/, client.sendRequest('$/lean/rpc/connect', connParams)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.sessionId];
            }
        });
    });
}
var RpcSessionAtPos = /** @class */ (function () {
    function RpcSessionAtPos(client, sessionId, uri) {
        var _this = this;
        this.sessionId = sessionId;
        this.uri = uri;
        this.client = client;
        this.keepAliveInterval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var params, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { uri: uri, sessionId: sessionId };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, client.sendNotification('$/lean/rpc/keepAlive', params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log("[InfoProvider] failed to send keepalive for ".concat(uri, ": ").concat(e_1));
                        if (this.keepAliveInterval != null)
                            clearInterval(this.keepAliveInterval);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, keepAlivePeriodMs);
    }
    RpcSessionAtPos.prototype.dispose = function () {
        if (this.keepAliveInterval != null)
            clearInterval(this.keepAliveInterval);
        // TODO: at this point we could close the session
    };
    return RpcSessionAtPos;
}());
var InfoProvider = /** @class */ (function () {
    function InfoProvider(myclient /*, private readonly leanDocs: DocumentSelector, private readonly context: ExtensionContext */) {
        var _this = this;
        this.myclient = myclient;
        this.subscriptions = [];
        this.clientSubscriptions = [];
        this.stylesheet = '';
        this.autoOpened = false;
        // private readonly clientProvider: LeanClientProvider
        // Subscriptions are counted and only disposed of when count becomes 0.
        this.serverNotifSubscriptions = new Map();
        this.clientNotifSubscriptions = new Map();
        this.rpcSessions = new Map();
        // the key is the LeanClient.getWorkspaceFolder()
        this.clientsFailed = new Map();
        // the key is the uri of the file who's worker has failed.
        this.workersFailed = new Map();
        this.editorApi = {
            sendClientRequest: function (uri, method, params) { return __awaiter(_this, void 0, void 0, function () {
                var client, result, ex_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            client = this.client // clientProvider.findClient(uri)
                            ;
                            if (!(client != null)) return [3 /*break*/, 6];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 6]);
                            return [4 /*yield*/, client.sendRequest(method, params)];
                        case 2:
                            result = _a.sent();
                            return [2 /*return*/, result];
                        case 3:
                            ex_1 = _a.sent();
                            if (!(ex_1.code === RpcErrorCode.WorkerCrashed)) return [3 /*break*/, 5];
                            // ex codes related with worker exited or crashed
                            console.log("[InfoProvider]The Lean Server has stopped processing this file: ".concat(ex_1.message));
                            return [4 /*yield*/, this.onWorkerStopped(uri, client, { message: 'The Lean Server has stopped processing this file: ', reason: ex_1.message })];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: throw ex_1;
                        case 6: return [2 /*return*/, undefined];
                    }
                });
            }); },
            sendClientNotification: function (uri, method, params) { return __awaiter(_this, void 0, void 0, function () {
                var client;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            client = this.client // this.clientProvider.findClient(uri)
                            ;
                            if (!(client != null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, client.sendNotification(method, params)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); },
            subscribeServerNotifications: function (method) { return __awaiter(_this, void 0, void 0, function () {
                var el, _a, count, h, subscriptions, _b, _c, client, subscriptions, _d, _f, client;
                var e_2, _g, e_3, _h;
                return __generator(this, function (_j) {
                    el = this.serverNotifSubscriptions.get(method);
                    if (el != null) {
                        _a = __read(el, 2), count = _a[0], h = _a[1];
                        this.serverNotifSubscriptions.set(method, [count + 1, h]);
                        return [2 /*return*/];
                    }
                    // NOTE(WN): For non-custom notifications we cannot call LanguageClient.onNotification
                    // here because that *overwrites* the notification handler rather than registers an extra one.
                    // So we have to add a bunch of event emitters to `LeanClient.`
                    if (method === 'textDocument/publishDiagnostics') {
                        subscriptions = [];
                        try {
                            for (_b = __values([this.client]) /* this.clientProvider.getClients() */, _c = _b.next(); !_c.done; _c = _b.next()) {
                                client = _c.value;
                                subscriptions.push(this.subscribeDiagnosticsNotification(client, method));
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_g = _b.return)) _g.call(_b);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        this.serverNotifSubscriptions.set(method, [1, subscriptions]);
                    }
                    else if (method.startsWith('$')) {
                        subscriptions = [];
                        try {
                            for (_d = __values([this.client]) /* this.clientProvider.getClients() */, _f = _d.next(); !_f.done; _f = _d.next()) {
                                client = _f.value;
                                subscriptions.push(this.subscribeCustomNotification(client, method));
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_h = _d.return)) _h.call(_d);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        this.serverNotifSubscriptions.set(method, [1, subscriptions]);
                    }
                    else {
                        throw new Error("subscription to ".concat(method, " server notifications not implemented"));
                    }
                    return [2 /*return*/];
                });
            }); },
            unsubscribeServerNotifications: function (method) { return __awaiter(_this, void 0, void 0, function () {
                var el, _a, count, subscriptions, subscriptions_1, subscriptions_1_1, h;
                var e_4, _b;
                return __generator(this, function (_c) {
                    el = this.serverNotifSubscriptions.get(method);
                    if (el == null)
                        return [2 /*return*/];
                    _a = __read(el, 2), count = _a[0], subscriptions = _a[1];
                    if (count === 1) {
                        try {
                            for (subscriptions_1 = __values(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()) {
                                h = subscriptions_1_1.value;
                                h.dispose();
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (subscriptions_1_1 && !subscriptions_1_1.done && (_b = subscriptions_1.return)) _b.call(subscriptions_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        this.serverNotifSubscriptions.delete(method);
                    }
                    else {
                        this.serverNotifSubscriptions.set(method, [count - 1, subscriptions]);
                    }
                    return [2 /*return*/];
                });
            }); },
            subscribeClientNotifications: function (method) { return __awaiter(_this, void 0, void 0, function () {
                var el, _a, count, d, subscriptions, _b, _c, client, subscriptions, _d, _f, client;
                var e_5, _g, e_6, _h;
                return __generator(this, function (_j) {
                    el = this.clientNotifSubscriptions.get(method);
                    if (el != null) {
                        _a = __read(el, 2), count = _a[0], d = _a[1];
                        this.clientNotifSubscriptions.set(method, [count + 1, d]);
                        return [2 /*return*/];
                    }
                    if (method === 'textDocument/didChange') {
                        subscriptions = [];
                        try {
                            for (_b = __values([this.client]) /* this.clientProvider.getClients() */, _c = _b.next(); !_c.done; _c = _b.next()) {
                                client = _c.value;
                                subscriptions.push(this.subscribeDidChangeNotification(client, method));
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_g = _b.return)) _g.call(_b);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        this.clientNotifSubscriptions.set(method, [1, subscriptions]);
                    }
                    else if (method === 'textDocument/didClose') {
                        subscriptions = [];
                        try {
                            for (_d = __values([this.client]) /* this.clientProvider.getClients() */, _f = _d.next(); !_f.done; _f = _d.next()) {
                                client = _f.value;
                                subscriptions.push(this.subscribeDidCloseNotification(client, method));
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_h = _d.return)) _h.call(_d);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        this.clientNotifSubscriptions.set(method, [1, subscriptions]);
                    }
                    else {
                        throw new Error("Subscription to '".concat(method, "' client notifications not implemented"));
                    }
                    return [2 /*return*/];
                });
            }); },
            unsubscribeClientNotifications: function (method) { return __awaiter(_this, void 0, void 0, function () {
                var el, _a, count, subscriptions, subscriptions_2, subscriptions_2_1, d;
                var e_7, _b;
                return __generator(this, function (_c) {
                    el = this.clientNotifSubscriptions.get(method);
                    if (el == null)
                        return [2 /*return*/];
                    _a = __read(el, 2), count = _a[0], subscriptions = _a[1];
                    if (count === 1) {
                        try {
                            for (subscriptions_2 = __values(subscriptions), subscriptions_2_1 = subscriptions_2.next(); !subscriptions_2_1.done; subscriptions_2_1 = subscriptions_2.next()) {
                                d = subscriptions_2_1.value;
                                d.dispose();
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (subscriptions_2_1 && !subscriptions_2_1.done && (_b = subscriptions_2.return)) _b.call(subscriptions_2);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                        this.clientNotifSubscriptions.delete(method);
                    }
                    else {
                        this.clientNotifSubscriptions.set(method, [count - 1, subscriptions]);
                    }
                    return [2 /*return*/];
                });
            }); },
            copyToClipboard: function (text) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, env.clipboard.writeText(text)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, window.showInformationMessage("Copied to clipboard: ".concat(text))];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            insertText: function (text, kind, tdpp) { return __awaiter(_this, void 0, void 0, function () {
                var uri, pos;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (tdpp != null) {
                                uri = p2cConverter.asUri(tdpp.textDocument.uri);
                                pos = fromLanguageServerPosition(tdpp.position);
                            }
                            return [4 /*yield*/, this.handleInsertText(text, kind, uri, pos)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            applyEdit: function (e) { return __awaiter(_this, void 0, void 0, function () {
                var we;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, p2cConverter.asWorkspaceEdit(e)];
                        case 1:
                            we = _a.sent();
                            return [4 /*yield*/, workspace.applyEdit(we)];
                        case 2:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            showDocument: function (show) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    void this.revealEditorSelection(Uri.parse(show.uri), fromLanguageServerRange(show.selection));
                    return [2 /*return*/];
                });
            }); },
            createRpcSession: function (uri) { return __awaiter(_this, void 0, void 0, function () {
                var client, sessionId, session;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            client = this.client // this.clientProvider.findClient(uri)
                            ;
                            if (client == null)
                                return [2 /*return*/, ''];
                            return [4 /*yield*/, rpcConnect(client, uri)];
                        case 1:
                            sessionId = _a.sent();
                            session = new RpcSessionAtPos(client, sessionId, uri);
                            // if (this.webviewPanel == null) {
                            //   session.dispose()
                            //   throw Error('infoview disconnect while connecting to RPC session')
                            // } else {
                            this.rpcSessions.set(sessionId, session);
                            return [2 /*return*/, sessionId
                                // }
                            ];
                    }
                });
            }); },
            closeRpcSession: function (sessionId) { return __awaiter(_this, void 0, void 0, function () {
                var session;
                return __generator(this, function (_a) {
                    session = this.rpcSessions.get(sessionId);
                    if (session != null) {
                        this.rpcSessions.delete(sessionId);
                        session.dispose();
                    }
                    return [2 /*return*/];
                });
            }); }
        };
        // this.clientProvider = provider
        this.client = myclient;
        this.updateStylesheet();
        this.onClientAdded(this.client);
        // provider.clientAdded((client) => {
        //   void this.onClientAdded(client)
        // })
        // provider.clientRemoved((client) => {
        //   void this.onClientRemoved(client)
        // })
        // provider.clientStopped(([client, activeClient, reason]) => {
        //   void this.onActiveClientStopped(client, activeClient, reason)
        // })
        this.subscriptions.push(window.onDidChangeActiveTextEditor(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.sendPosition()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }), window.onDidChangeTextEditorSelection(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.sendPosition()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }), workspace.onDidChangeConfiguration(function (_e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // regression; changing the style needs a reload. :/
                        this.updateStylesheet();
                        return [4 /*yield*/, this.sendConfig()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }), workspace.onDidChangeTextDocument(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendPosition()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })
        // commands.registerTextEditorCommand('lean4.displayGoal', async (editor) => await this.openPreview(editor, this.infoviewApi!)),
        // commands.registerTextEditorCommand('lean4.toggleInfoview', async (editor) => await this.toggleInfoview(editor)),
        // commands.registerTextEditorCommand('lean4.displayList', async (editor) => {
        //   await this.openPreview(editor, this.infoviewApi!)
        //   await this.infoviewApi?.requestedAction({ kind: 'toggleAllMessages' })
        // }),
        // commands.registerTextEditorCommand('lean4.infoView.copyToComment',
        //   () => this.infoviewApi?.requestedAction({ kind: 'copyToComment' })),
        // commands.registerCommand('lean4.infoView.toggleUpdating', () =>
        //   this.infoviewApi?.requestedAction({ kind: 'togglePaused' })),
        // commands.registerTextEditorCommand('lean4.infoView.toggleStickyPosition',
        //   () => this.infoviewApi?.requestedAction({ kind: 'togglePin' }))
        );
    }
    InfoProvider.prototype.subscribeDidChangeNotification = function (client, method) {
        var _this = this;
        var h = client.didChange(function (params) {
            var _a;
            void ((_a = _this.infoviewApi) === null || _a === void 0 ? void 0 : _a.sentClientNotification(method, params));
        });
        return h;
    };
    InfoProvider.prototype.subscribeDidCloseNotification = function (client, method) {
        var _this = this;
        var h = client.didClose(function (params) {
            var _a;
            void ((_a = _this.infoviewApi) === null || _a === void 0 ? void 0 : _a.sentClientNotification(method, params));
        });
        return h;
    };
    InfoProvider.prototype.subscribeDiagnosticsNotification = function (client, method) {
        var _this = this;
        var h = client.diagnostics(function (params) {
            var _a;
            void ((_a = _this.infoviewApi) === null || _a === void 0 ? void 0 : _a.gotServerNotification(method, params));
        });
        return h;
    };
    InfoProvider.prototype.subscribeCustomNotification = function (client, method) {
        var _this = this;
        var h = client.customNotification(function (_a) {
            var _b;
            var thisMethod = _a.method, params = _a.params;
            if (thisMethod !== method)
                return;
            void ((_b = _this.infoviewApi) === null || _b === void 0 ? void 0 : _b.gotServerNotification(method, params));
        });
        return h;
    };
    InfoProvider.prototype.onClientRestarted = function (client) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, method, _d, count, subscriptions, _f, _g, _h, method, _j, count, subscriptions, folder, _k, _l, uri;
            var e_8, _m, e_9, _o, e_10, _p;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        try {
                            // if we already have subscriptions for a previous client, we need to also
                            // subscribe to the same things on this new client.
                            for (_a = __values(this.clientNotifSubscriptions), _b = _a.next(); !_b.done; _b = _a.next()) {
                                _c = __read(_b.value, 2), method = _c[0], _d = __read(_c[1], 2), count = _d[0], subscriptions = _d[1];
                                if (method === 'textDocument/didChange') {
                                    subscriptions.push(this.subscribeDidChangeNotification(client, method));
                                }
                                else if (method === 'textDocument/didClose') {
                                    subscriptions.push(this.subscribeDidCloseNotification(client, method));
                                }
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_m = _a.return)) _m.call(_a);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                        try {
                            for (_f = __values(this.serverNotifSubscriptions), _g = _f.next(); !_g.done; _g = _f.next()) {
                                _h = __read(_g.value, 2), method = _h[0], _j = __read(_h[1], 2), count = _j[0], subscriptions = _j[1];
                                if (method === 'textDocument/publishDiagnostics') {
                                    subscriptions.push(this.subscribeDiagnosticsNotification(client, method));
                                }
                                else if (method.startsWith('$')) {
                                    subscriptions.push(this.subscribeCustomNotification(client, method));
                                }
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (_g && !_g.done && (_o = _f.return)) _o.call(_f);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                        folder = client.getWorkspaceFolder();
                        try {
                            for (_k = __values(this.workersFailed.keys()), _l = _k.next(); !_l.done; _l = _k.next()) {
                                uri = _l.value;
                                if (uri.startsWith(folder)) {
                                    this.workersFailed.delete(uri);
                                }
                            }
                        }
                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
                        finally {
                            try {
                                if (_l && !_l.done && (_p = _k.return)) _p.call(_k);
                            }
                            finally { if (e_10) throw e_10.error; }
                        }
                        if (this.clientsFailed.has(folder)) {
                            this.clientsFailed.delete(folder);
                        }
                        return [4 /*yield*/, this.initInfoView(this.editor, client)];
                    case 1:
                        _q.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.onClientAdded = function (client) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                console.log("[InfoProvider] Adding client for workspace: ".concat(client.getWorkspaceFolder()));
                this.clientSubscriptions.push(client.restarted(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('[InfoProvider] got client restarted event');
                                // This event is triggered both the first time the server starts
                                // as well as when the server restarts.
                                this.clearRpcSessions(client);
                                // Need to fully re-initialize this newly restarted client with all the
                                // existing subscriptions and resend position info and so on so the
                                // infoview updates properly.
                                return [4 /*yield*/, this.onClientRestarted(client)];
                            case 1:
                                // Need to fully re-initialize this newly restarted client with all the
                                // existing subscriptions and resend position info and so on so the
                                // infoview updates properly.
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }), client.restartedWorker(function (uri) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('[InfoProvider] got worker restarted event');
                                return [4 /*yield*/, this.onWorkerRestarted(uri)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }), client.didSetLanguage(function () { return _this.onLanguageChanged(); }));
                return [2 /*return*/];
            });
        });
    };
    InfoProvider.prototype.onWorkerRestarted = function (uri) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.infoviewApi) === null || _a === void 0 ? void 0 : _a.serverStopped(undefined))]; // clear any server stopped state
                    case 1:
                        _b.sent(); // clear any server stopped state
                        if (this.workersFailed.has(uri)) {
                            this.workersFailed.delete(uri);
                            console.log('[InfoProvider] Restarting worker for file: ' + uri);
                        }
                        return [4 /*yield*/, this.sendPosition()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.onWorkerStopped = function (uri, client, reason) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.infoviewApi) === null || _a === void 0 ? void 0 : _a.serverStopped(reason))];
                    case 1:
                        _b.sent();
                        if (!this.workersFailed.has(uri)) {
                            this.workersFailed.set(uri, reason);
                        }
                        console.log("[InfoProvider]client crashed: ".concat(uri));
                        return [4 /*yield*/, client.showRestartMessage()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.onClientRemoved = function (client) {
        // todo: remove subscriptions for this client...
    };
    InfoProvider.prototype.onActiveClientStopped = function (client, activeClient, reason) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!activeClient) return [3 /*break*/, 2];
                        // means that client and active client are the same and just show the error message
                        return [4 /*yield*/, ((_a = this.infoviewApi) === null || _a === void 0 ? void 0 : _a.serverStopped(reason))];
                    case 1:
                        // means that client and active client are the same and just show the error message
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        console.log("[InfoProvider] client stopped: ".concat(client.getWorkspaceFolder()));
                        key = client.getWorkspaceFolder();
                        if (!key) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.sendPosition()];
                    case 3:
                        _b.sent();
                        if (!this.clientsFailed.has(key)) {
                            this.clientsFailed.set(key, reason);
                        }
                        console.log("[InfoProvider] client stopped: ".concat(key));
                        return [4 /*yield*/, client.showRestartMessage()];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.dispose = function () {
        var e_11, _a, e_12, _b;
        // active client is changing.
        this.clearNotificationHandlers();
        this.clearRpcSessions(null);
        try {
            for (var _c = __values(this.clientSubscriptions), _d = _c.next(); !_d.done; _d = _c.next()) {
                var s = _d.value;
                s.dispose();
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_11) throw e_11.error; }
        }
        try {
            for (var _f = __values(this.subscriptions), _g = _f.next(); !_g.done; _g = _f.next()) {
                var s = _g.value;
                s.dispose();
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_12) throw e_12.error; }
        }
    };
    InfoProvider.prototype.isOpen = function () {
        return /* this.webviewPanel?.visible === */ true;
    };
    InfoProvider.prototype.runTestScript = function (javaScript) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.infoviewApi != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.infoviewApi.runTestScript(javaScript)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: throw new Error('Cannot run test script, infoview is closed.');
                }
            });
        });
    };
    InfoProvider.prototype.getHtmlContents = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.infoviewApi != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.infoviewApi.getInfoviewHtml()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: throw new Error('Cannot retrieve infoview HTML, infoview is closed.');
                }
            });
        });
    };
    InfoProvider.prototype.sleep = function (ms) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    InfoProvider.prototype.toggleAllMessages = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.infoviewApi != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.infoviewApi.requestedAction({ kind: 'toggleAllMessages' })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.updateStylesheet = function () {
        // // Here we add extra CSS variables which depend on the editor configuration,
        // // but are not exposed by default.
        // // Ref: https://code.visualstudio.com/api/extension-guides/webview#theming-webview-content
        // const extraCSS = `
        //         html {
        //             --vscode-editor-line-height: ${getEditorLineHeight()}px;
        //         }
        //     `
        // const configCSS = getInfoViewStyle()
        // this.stylesheet = extraCSS + configCSS
    };
    InfoProvider.prototype.autoOpen = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // if ((this.webviewPanel == null) && !this.autoOpened && getInfoViewAutoOpen() && (window.activeTextEditor != null)) {
                //   // only auto-open for lean files, not for markdown.
                //   if (languages.match(this.leanDocs, window.activeTextEditor.document)) {
                //     // remember we've auto opened during this session so if user closes it it remains closed.
                //     this.autoOpened = true
                //     await this.openPreview(window.activeTextEditor)
                //     return true
                //   }
                // }
                return [2 /*return*/, false];
            });
        });
    };
    InfoProvider.prototype.clearNotificationHandlers = function () {
        var e_13, _a, e_14, _b, e_15, _c, e_16, _d;
        try {
            for (var _f = __values(this.clientNotifSubscriptions), _g = _f.next(); !_g.done; _g = _f.next()) {
                var _h = __read(_g.value, 2), _j = __read(_h[1], 2), subscriptions = _j[1];
                try {
                    for (var subscriptions_3 = (e_14 = void 0, __values(subscriptions)), subscriptions_3_1 = subscriptions_3.next(); !subscriptions_3_1.done; subscriptions_3_1 = subscriptions_3.next()) {
                        var h = subscriptions_3_1.value;
                        h.dispose();
                    }
                }
                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                finally {
                    try {
                        if (subscriptions_3_1 && !subscriptions_3_1.done && (_b = subscriptions_3.return)) _b.call(subscriptions_3);
                    }
                    finally { if (e_14) throw e_14.error; }
                }
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            }
            finally { if (e_13) throw e_13.error; }
        }
        this.clientNotifSubscriptions.clear();
        try {
            for (var _k = __values(this.serverNotifSubscriptions), _l = _k.next(); !_l.done; _l = _k.next()) {
                var _m = __read(_l.value, 2), _o = __read(_m[1], 2), subscriptions = _o[1];
                try {
                    for (var subscriptions_4 = (e_16 = void 0, __values(subscriptions)), subscriptions_4_1 = subscriptions_4.next(); !subscriptions_4_1.done; subscriptions_4_1 = subscriptions_4.next()) {
                        var h = subscriptions_4_1.value;
                        h.dispose();
                    }
                }
                catch (e_16_1) { e_16 = { error: e_16_1 }; }
                finally {
                    try {
                        if (subscriptions_4_1 && !subscriptions_4_1.done && (_d = subscriptions_4.return)) _d.call(subscriptions_4);
                    }
                    finally { if (e_16) throw e_16.error; }
                }
            }
        }
        catch (e_15_1) { e_15 = { error: e_15_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            }
            finally { if (e_15) throw e_15.error; }
        }
        this.serverNotifSubscriptions.clear();
    };
    InfoProvider.prototype.clearRpcSessions = function (client) {
        var e_17, _a;
        var remaining = new Map();
        try {
            for (var _b = __values(this.rpcSessions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), sessionId = _d[0], sess = _d[1];
                if (client === null || sess.client === client) {
                    sess.dispose();
                }
                else {
                    remaining.set(sessionId, sess);
                }
            }
        }
        catch (e_17_1) { e_17 = { error: e_17_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_17) throw e_17.error; }
        }
        this.rpcSessions = remaining;
    };
    InfoProvider.prototype.toggleInfoview = function (editor) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    InfoProvider.prototype.getApi = function () {
        return this.editorApi;
    };
    InfoProvider.prototype.openPreview = function (editor, infoviewApi) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.infoviewApi = infoviewApi;
                        this.editor = editor;
                        // let column = editor && editor.viewColumn ? editor.viewColumn + 1 : ViewColumn.Two
                        // if (column === 4) { column = ViewColumn.Three }
                        // if (this.webviewPanel != null) {
                        //   this.webviewPanel.reveal(column, true)
                        // } else {
                        //   const webviewPanel = window.createWebviewPanel('lean4', 'Lean Infoview',
                        //     { viewColumn: column, preserveFocus: true },
                        //     {
                        //       enableFindWidget: true,
                        //       retainContextWhenHidden: true,
                        //       enableScripts: true,
                        //       enableCommandUris: true
                        //     }) as WebviewPanel & { rpc: Rpc, api: InfoviewApi }
                        // Note that an extension can send data to its webviews using webview.postMessage().
                        // This method sends any JSON serializable data to the webview. The message is received
                        // inside the webview through the standard message event.
                        // The receiving of these messages is done inside webview\index.ts where it
                        // calls window.addEventListener('message',...
                        // webviewPanel.rpc = new Rpc(m => {
                        //   try {
                        //     void webviewPanel.webview.postMessage(m)
                        //   } catch (e) {
                        //     // ignore any disposed object exceptions
                        //   }
                        // })
                        // webviewPanel.rpc.register(this.editorApi)
                        // // Similarly, we can received data from the webview by listening to onDidReceiveMessage.
                        // webviewPanel.webview.onDidReceiveMessage(m => {
                        //   try {
                        //     webviewPanel.rpc.messageReceived(m)
                        //   } catch {
                        //     // ignore any disposed object exceptions
                        //   }
                        // })
                        // webviewPanel.api = webviewPanel.rpc.getApi()
                        // webviewPanel.onDidDispose(() => {
                        //   this.webviewPanel = undefined
                        //   this.clearNotificationHandlers()
                        //   this.clearRpcSessions(null) // should be after `webviewPanel = undefined`
                        // })
                        // this.webviewPanel = webviewPanel
                        // webviewPanel.webview.html = this.initialHtml()
                        // const uri = editor.document?.uri?.toString()
                        // const client = this.clientProvider.findClient(uri)
                        return [4 /*yield*/, this.initInfoView(editor, this.client)
                            // }
                        ];
                    case 1:
                        // let column = editor && editor.viewColumn ? editor.viewColumn + 1 : ViewColumn.Two
                        // if (column === 4) { column = ViewColumn.Three }
                        // if (this.webviewPanel != null) {
                        //   this.webviewPanel.reveal(column, true)
                        // } else {
                        //   const webviewPanel = window.createWebviewPanel('lean4', 'Lean Infoview',
                        //     { viewColumn: column, preserveFocus: true },
                        //     {
                        //       enableFindWidget: true,
                        //       retainContextWhenHidden: true,
                        //       enableScripts: true,
                        //       enableCommandUris: true
                        //     }) as WebviewPanel & { rpc: Rpc, api: InfoviewApi }
                        // Note that an extension can send data to its webviews using webview.postMessage().
                        // This method sends any JSON serializable data to the webview. The message is received
                        // inside the webview through the standard message event.
                        // The receiving of these messages is done inside webview\index.ts where it
                        // calls window.addEventListener('message',...
                        // webviewPanel.rpc = new Rpc(m => {
                        //   try {
                        //     void webviewPanel.webview.postMessage(m)
                        //   } catch (e) {
                        //     // ignore any disposed object exceptions
                        //   }
                        // })
                        // webviewPanel.rpc.register(this.editorApi)
                        // // Similarly, we can received data from the webview by listening to onDidReceiveMessage.
                        // webviewPanel.webview.onDidReceiveMessage(m => {
                        //   try {
                        //     webviewPanel.rpc.messageReceived(m)
                        //   } catch {
                        //     // ignore any disposed object exceptions
                        //   }
                        // })
                        // webviewPanel.api = webviewPanel.rpc.getApi()
                        // webviewPanel.onDidDispose(() => {
                        //   this.webviewPanel = undefined
                        //   this.clearNotificationHandlers()
                        //   this.clearRpcSessions(null) // should be after `webviewPanel = undefined`
                        // })
                        // this.webviewPanel = webviewPanel
                        // webviewPanel.webview.html = this.initialHtml()
                        // const uri = editor.document?.uri?.toString()
                        // const client = this.clientProvider.findClient(uri)
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.initInfoView = function (editor, client) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var loc;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(editor != null)) return [3 /*break*/, 2];
                        loc = this.getLocation(editor);
                        if (!(loc != null)) return [3 /*break*/, 2];
                        console.log('initialize infoview api');
                        return [4 /*yield*/, ((_a = this.infoviewApi) === null || _a === void 0 ? void 0 : _a.initialize(loc))];
                    case 1:
                        _d.sent();
                        _d.label = 2;
                    case 2:
                        if (!((client === null || client === void 0 ? void 0 : client.initializeResult) != null)) return [3 /*break*/, 9];
                        return [4 /*yield*/, ((_b = this.infoviewApi) === null || _b === void 0 ? void 0 : _b.serverStopped(undefined))]; // clear any server stopped state
                    case 3:
                        _d.sent(); // clear any server stopped state
                        return [4 /*yield*/, ((_c = this.infoviewApi) === null || _c === void 0 ? void 0 : _c.serverRestarted(client.initializeResult))];
                    case 4:
                        _d.sent();
                        return [4 /*yield*/, this.sendDiagnostics(client)];
                    case 5:
                        _d.sent();
                        return [4 /*yield*/, this.sendProgress(client)];
                    case 6:
                        _d.sent();
                        return [4 /*yield*/, this.sendPosition()];
                    case 7:
                        _d.sent();
                        return [4 /*yield*/, this.sendConfig()];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.sendConfig = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.infoviewApi) === null || _a === void 0 ? void 0 : _a.changedInfoviewConfig({
                            allErrorsOnLine: true,
                            autoOpenShowsGoal: true,
                            debounceTime: 50 // getInfoViewAutoOpenShowGoal()
                        }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.sendDiagnostics = function (client) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                if (this.infoviewApi !== undefined) {
                    (_a = client.getDiagnostics()) === null || _a === void 0 ? void 0 : _a.forEach(function (uri, diags) { return __awaiter(_this, void 0, void 0, function () {
                        var params;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    params = client.getDiagnosticParams(uri, diags);
                                    return [4 /*yield*/, this.infoviewApi.gotServerNotification('textDocument/publishDiagnostics', params)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                return [2 /*return*/];
            });
        });
    };
    InfoProvider.prototype.sendProgress = function (client) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, uri, processing, params, e_18_1;
            var e_18, _d;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (this.infoviewApi == null)
                            return [2 /*return*/];
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        _a = __values(client.progress), _b = _a.next();
                        _f.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        _c = __read(_b.value, 2), uri = _c[0], processing = _c[1];
                        params = {
                            textDocument: {
                                uri: c2pConverter.asUri(uri),
                                version: 0 // HACK: The infoview ignores this
                            },
                            processing: processing
                        };
                        return [4 /*yield*/, this.infoviewApi.gotServerNotification('$/lean/fileProgress', params)];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_18_1 = _f.sent();
                        e_18 = { error: e_18_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                        }
                        finally { if (e_18) throw e_18.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.onLanguageChanged = function () {
        var _this = this;
        this.autoOpen().then(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendPosition()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sendConfig()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }).catch(function () { });
    };
    InfoProvider.prototype.getLocation = function (editor) {
        var _a;
        if (!editor)
            return undefined;
        var uri = (_a = editor.getModel()) === null || _a === void 0 ? void 0 : _a.uri;
        var selection = editor.getSelection();
        return {
            uri: uri.toString(),
            range: toLanguageServerRange(selection)
        };
    };
    InfoProvider.prototype.sendPosition = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var editor, loc, client, uri, folder, reason;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        editor = this.editor;
                        if (editor == null)
                            return [2 /*return*/];
                        loc = this.getLocation(editor);
                        if (!(this.clientsFailed.size > 0 || this.workersFailed.size > 0)) return [3 /*break*/, 7];
                        client = this.client // this.clientProvider.findClient(editor.document.uri.toString())
                        ;
                        if (!(client != null)) return [3 /*break*/, 5];
                        uri = (_b = (_a = window.activeTextEditor) === null || _a === void 0 ? void 0 : _a.document.uri.toString()) !== null && _b !== void 0 ? _b : '';
                        folder = client.getWorkspaceFolder();
                        reason = void 0;
                        if (this.clientsFailed.has(folder)) {
                            reason = this.clientsFailed.get(folder);
                        }
                        else if (this.workersFailed.has(uri)) {
                            reason = this.workersFailed.get(uri);
                        }
                        if (!reason) return [3 /*break*/, 2];
                        // send stopped event
                        return [4 /*yield*/, ((_c = this.infoviewApi) === null || _c === void 0 ? void 0 : _c.serverStopped(reason))];
                    case 1:
                        // send stopped event
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.updateStatus(loc)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        console.log('[InfoProvider] ### what does it mean to have sendPosition but no LeanClient for this document???');
                        _d.label = 6;
                    case 6: return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.updateStatus(loc)];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.updateStatus = function (loc) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // await this.infoviewApi?.serverStopped('update status') // clear any server stopped state
                    return [4 /*yield*/, this.autoOpen()];
                    case 1:
                        // await this.infoviewApi?.serverStopped('update status') // clear any server stopped state
                        _b.sent();
                        return [4 /*yield*/, ((_a = this.infoviewApi) === null || _a === void 0 ? void 0 : _a.changedCursorLocation(loc))];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.revealEditorSelection = function (uri, selection) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.editor == null) {
                    console.error("Editor not set");
                    return [2 /*return*/];
                }
                if (selection !== undefined) {
                    this.editor.revealRange(selection); //TextEditorRevealType.InCenterIfOutsideViewport
                    this.editor.setSelection(selection);
                    // ensure the text document has the keyboard focus.
                    this.editor.focus();
                }
                return [2 /*return*/];
            });
        });
    };
    InfoProvider.prototype.handleInsertText = function (text, kind, uri, pos) {
        return __awaiter(this, void 0, void 0, function () {
            var spaces, margin_str, new_command, insertPosition;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.editor == null) {
                            return [2 /*return*/];
                        }
                        pos = (pos != null) ? pos : this.editor.getSelection().getStartPosition();
                        if (!(kind === 'above')) return [3 /*break*/, 3];
                        spaces = this.editor.getModel().getLineFirstNonWhitespaceColumn(pos.lineNumber) - 1;
                        margin_str = __spreadArray([], __read(Array(spaces).keys()), false).map(function (x) { return ' '; }).join('');
                        new_command = text.replace(/\n/g, '\n' + margin_str);
                        new_command = "".concat(margin_str).concat(new_command, "\n");
                        insertPosition = monaco.Range.fromPositions({ lineNumber: pos.lineNumber, column: 0 });
                        return [4 /*yield*/, this.editor.pushUndoStop()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.editor.executeEdits("infoview", [{ range: insertPosition, text: new_command, forceMoveMarkers: true }])];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(pos != null)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.editor.pushUndoStop()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.editor.executeEdits("infoview", [{ range: monaco.Range.fromPositions(pos), text: text, forceMoveMarkers: true }])];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        this.editor.focus();
                        return [2 /*return*/];
                }
            });
        });
    };
    InfoProvider.prototype.getLocalPath = function (path) {
        // if (this.webviewPanel != null) {
        //   return this.webviewPanel.webview.asWebviewUri(
        //     Uri.file(join(this.context.extensionPath, path))).toString()
        // }
        return undefined;
    };
    return InfoProvider;
}());
export { InfoProvider };
